import styled from "styled-components"

export const Container = styled.div`
    background: #cecece;
`
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`